<div class="RepairCosts">
  <h3 class="RepairCosts__Heading">Current Itemized Repairs</h3>
  <div
    class="RepairCosts__CurrentRepairs d-flex justify-content-between flex-wrap w-100"
  >
    @for (renovation of renovationList; track renovation) {
      <div class="RepairCosts__CurrentRepair flex">
        <h4 class="RepairCosts__Content" [innerHTML]="renovation.name"></h4>
        <span>:&nbsp;</span>
        <label [innerHTML]="renovation.cost | currency"></label>
      </div>
    }
  </div>

  <!-- Open Modal Button -->
  <form [formGroup]="repairForm" class="RepairCosts__Form">
    <!-- <ion-item [formGroup]="repairForm"> -->
    <!-- <ion-input [formControlName]="'total'" [placeholder]="'Rehab Total'" disabled></ion-input> -->
    <ion-button
      aria-label="Renovation Details"
      color="primary"
      class="RepairCosts__Button"
      data-test-id="renovationDetailsButton"
      id="renovation-details"
      fill="solid"
      (click)="showDetails()"
    >
      <ion-icon name="list" slot="start"></ion-icon>
      <span>Itemize</span>
    </ion-button>
    <!-- </ion-item> -->
  </form>
</div>
